<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto flex max-w-screen-xl flex-col">
      <component :is="heading" v-if="title" class="mb-4">{{ title }}</component>
      <iframe
        id=""
        title="yt-video"
        class="aspect-video h-full w-full"
        type="text/html"
        :src="videoUrl"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  heading?: string;
  title?: string;
  videoUrl?: string;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)",
  ];
});
</script>
